import { IVisualQuote } from '@seb/web-design-system/visual-quote';

import { blockQuoteSkeleton } from '../../models/skeleton/block-quote.skeleton';

export const quoteSkeleton: IVisualQuote = {
  image: {},
  quote: blockQuoteSkeleton
};
